import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Link,TextField } from '@mui/material';
import {TEXT_MSGS,PREMIUM_UPGRADE_MSGS_LIST, PAYMENT_METHOD_CCAVENUE,PAYMENT_METHOD_RAZORPAY} from '../../../common/utility/constant';
import { useNavigate } from "react-router-dom";
import WarnIcon from '@mui/icons-material/Warning';
import { useAxiosWithAuth } from '../../../common/api/hooks/useAxiosWithAuth';
import { useEffect,useState } from 'react';
import { URL } from '../../../common/api/urls';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import RupeeIcon from '@mui/icons-material/CurrencyRupee';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import usePermissions from '../../../common/hooks/usePermissions';

const DIWALI_BOGO_COUPON = 'DIWALI_BOGO';
const DIWALI_BOGO_MESSAGE = 'Congratulations!\nThis offer doubles your subscription period at no extra cost.';
const DIWALI_BOGO_NOTE = 'NOTE: Additional validity is added after successful payment.';

const isDiwaliBogo = (code) => String(code || '').trim().toUpperCase() === DIWALI_BOGO_COUPON;

const couponAppliedMessage = (detail) => {
  if (isDiwaliBogo(detail?.discount_code)) {
    return DIWALI_BOGO_MESSAGE;
  }
  return `Congratulations! You are eligible for a discount of ${detail.discount_percent}% on your order.`;
};




// const style = {
//   position: 'absolute',
//   top: '50%',
//   left: '50%',
//   transform: 'translate(-50%, -50%)',
// //   width: 500,
//   bgcolor: 'background.paper',
// //   border: '2px solid #000',
//   boxShadow: 24,
//   p: 3,
//   overflow: 'scroll',
// };
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 700,
  maxHeight: '90vh',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 2,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
};

export default function OrderDetailPopup(props) {

  const permissions = usePermissions();

  const isRazorpayAllowed = permissions.isPro2User()
  const [open, setOpen] = React.useState(true);
  const handleClose = () => {
    setOpen(false)
    props.onCancel();
}
const [data,setData]=useState(props.data);
const [code, setCode] = useState(undefined);
const [codeApplied,setCodeApplied]=useState(false);
const [couponDesc,setCouponDesc]=useState(false);
const [orderDetail,setOrderDetail]=useState(false);
const [isCouponError,setIsCouponError]=useState(undefined);
const [couponCode,setCouponCode]=useState(undefined);
const [paymentMethod, setPaymentMethod] = useState(PAYMENT_METHOD_CCAVENUE);

const handlePaymentMethodChange = (event) => {
  setPaymentMethod(event.target.value);
};



const [cancelOrderDetail,responseDataOrderDetail,errorOrderDetail,loadedOrderDetail,resetOrderDetail,executeAPIOrderDetail] = useAxiosWithAuth();

useEffect(() => {
  if (props.data && props.data.discount_code && props.data.discount_code !== "" && (props.data.discount_percent > 0 || isDiwaliBogo(props.data.discount_code))) {
    setCode(props.data.discount_code);
    setCouponCode(props.data.discount_code);
    setCodeApplied(true);
    setOrderDetail(props.data);
    setCouponDesc(couponAppliedMessage(props.data));
  }
}, []);

const cancel=()=>{
    props.onCancel();
}

const proceed = () => {
  props.onProceed(
    couponCode,
    paymentMethod
  );
};

const diwaliOfferApplied = isDiwaliBogo(orderDetail?.discount_code) || isDiwaliBogo(couponCode);

const formatINR = (amount) =>
  Number(amount).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const isFlexAddOn = props.isFlexAddOn ?? props.isFlexTopUp;

const applyRemoveCoupon=(code=undefined)=>{
  setIsCouponError(false);
  setCouponDesc("");
  if(code && code!="" && code.trim()!=""){
    let data={"plan_name": props.planName,"status_check":1,"disc_coupon":code.trim(), "payment_method":PAYMENT_METHOD_CCAVENUE}
    if (isFlexAddOn) {
      data["flex"] = 1;
    }
    setCode(code.toUpperCase());
    setCouponCode(code.trim());
    setCodeApplied(false);
    executeAPIOrderDetail(URL.SUBSCRIPTION_ORDER,"POST",data)
  }else{
    setCouponCode(undefined);
    setCodeApplied(false);
    setCode(undefined);
    setOrderDetail(false);
    let data={"plan_name": props.planName,"status_check":1, "payment_method":PAYMENT_METHOD_CCAVENUE}
    if (isFlexAddOn) {
      data["flex"] = 1;
    }
    executeAPIOrderDetail(URL.SUBSCRIPTION_ORDER,"POST",data)
  }

}

const handleCodeChange = (event) => {
  setIsCouponError(false);
  setCode(event.target.value);
};



    /**
   * API response handler subscription data
   */  
    useEffect(() => {
      // console.log("OrderDetails=",responseDataOrderDetail);
      if(loadedOrderDetail){
        if(responseDataOrderDetail!=null){
          if(responseDataOrderDetail.success!=undefined && responseDataOrderDetail.success==true){
            setData(responseDataOrderDetail);
              // console.log("OrderDetails 1=",responseDataOrderDetail);
              if(couponCode){
                // console.log("coupon 1=",couponCode)
                const bogoApplied = isDiwaliBogo(responseDataOrderDetail.discount_code);
                if(responseDataOrderDetail.discount_code=="" || (responseDataOrderDetail.discount_percent==0 && !bogoApplied)){
                  setCouponCode(undefined);
                  setIsCouponError(true);
                }
                else {
                  setCodeApplied(true);
                  setCouponDesc(couponAppliedMessage(responseDataOrderDetail));
                  setOrderDetail(responseDataOrderDetail);
                }
              }else{
                // console.log("coupon 2=",couponCode)
                setCouponCode(undefined);
                setIsCouponError(false);
                setCodeApplied(false);
                setCode(undefined);
                setOrderDetail(false);
              }
            
          }
          
          
        }
        else if(errorOrderDetail!==null){
          // setMsgState({open:true,msg:errorOrderDetail?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
          //if unauthorized then redirec it to login page
          if(errorOrderDetail?.response?.status === 401 || errorOrderDetail?.response?.status === 403){
            console.log("status received =",errorOrderDetail?.response?.status)
            // navigate(from, { replace: true });
          }
      }
      resetOrderDetail();
      }
    },[loadedOrderDetail,responseDataOrderDetail]);
    

  return (
    
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
        <Box sx={{ overflowY: 'auto', flexGrow: 1 }}>
          <Typography sx={{fontSize:"34px",fontWeight:600,textAlign:"center"}}>
            Purchase Details
          </Typography>
          {data.current_status!=undefined && data.current_status.length>0?
            <Box sx={{mt:2,display:'flex',justifyContent:"center"}}>
                <Box sx={{display:'flex',mb:1,pb:1,background:"#fff",borderRadius:"8px",pl:2,pr:2,mt:1,flexDirection:'column',width:"100%"}}>
                    {data.current_status.map((item,index) => (
                        
                        <>
                            {index==0?
                            <Typography  sx={{mb:1,mt:1,textAlign:'center',color:"#1e3a8a",fontSize:"20px",fontWeight:600}}>Active Subscription(s)</Typography>:
                            <></>}
                            <Box sx={{display:'flex',mb:1,pb:0,background:"#bfd2f2",borderRadius:"8px",pl:2,pr:2,mt:0,pt:1,flexDirection:'column'}}>
                                <Box sx={{display:'flex'}}>
                                    <Typography  sx={{mb:1,textAlign:'start',color:"#0d203f",fontWeight:600,minWidth:"140px"}}>Plan Details:</Typography>
                                    <Typography  sx={{mb:1,ml:1,textAlign:'start',color:"#0d203f"}}>{item.description}</Typography>
                                </Box>
                                <Box sx={{display:'flex'}}>
                                    <Typography  sx={{mb:1,textAlign:'start',color:"#0d203f",fontWeight:600,minWidth:"140px"}}>Plan Access:</Typography>
                                    <Typography  sx={{mb:1,ml:1,textAlign:'start',color:"#0d203f"}}>{item.plan_access}</Typography>
                                </Box>
                                <Box sx={{display:'flex'}}>
                                    <Typography  sx={{mb:2,color:"#0d203f",fontWeight:600,minWidth:"140px"}}>Expiry:</Typography>
                                    <Typography  sx={{mb:2,ml:1,color:"#0d203f"}}>{item.expiry_on}&nbsp;(in&nbsp;{item.remaining_days}&nbsp;days)</Typography>
                                </Box>
                            </Box>
                        </>  
                    ))}
                </Box>
                 
            </Box>:
            <>
            </>
          }

{data.after_payment!=undefined && data.after_payment.length>0?
            <Box sx={{mt:2,display:'flex',justifyContent:"start"}}>
                <Box sx={{display:'flex',mb:1,pb:1,background:"#fff",borderRadius:"8px",pl:2,pr:2,mt:1,flexDirection:'column',width:"100%"}}>
                <Typography  sx={{mb:1,mt:1,textAlign:'center',color:"#1e3a8a",fontSize:"20px",fontWeight:600}}>New Subscription after payment</Typography>
                    {data.after_payment.map((item,index) => (
                        
                        <>
                            
                            <Box sx={{display:'flex',mb:1,pb:0,background:"#bfd2f2",borderRadius:"8px",pl:2,pr:2,mt:0,pt:1,flexDirection:'column'}}>
                                <Box sx={{display:'flex'}}>
                                    <Typography  sx={{mb:1,textAlign:'start',color:"#0d203f",fontWeight:600,minWidth:"140px"}}>Plan Details:</Typography>
                                    <Typography  sx={{mb:1,ml:1,textAlign:'start',color:"#0d203f"}}>{item.description}</Typography>
                                </Box>
                                <Box sx={{display:'flex'}}>
                                    <Typography  sx={{mb:1,textAlign:'start',color:"#0d203f",fontWeight:600,minWidth:"140px"}}>Plan Access:</Typography>
                                    <Typography  sx={{mb:1,ml:1,textAlign:'start',color:"#0d203f"}}>{item.plan_access}</Typography>
                                </Box>
                                {item.remaining_days>0?
                                    <Box sx={{display:'flex'}}>
                                        <Typography  sx={{mb:1,color:"#0d203f",fontWeight:600,minWidth:"140px"}}>Expiry:</Typography>
                                        <Typography  sx={{mb:1,ml:1,color:"#0d203f"}}>{item.expiry_on}&nbsp;(in&nbsp;{item.remaining_days}&nbsp;days)</Typography>
                                    </Box>
                                    :
                                    <></>
                                }
                                {item.additional_comments && item.additional_comments!=""?
                                    <Box sx={{display:'flex'}}>
                                        <Typography  sx={{mb:2,color:"#0d203f",fontWeight:600,minWidth:"140px"}}>Notes:</Typography>
                                        <Typography  sx={{mb:2,ml:1,color:"#0d203f"}}>{item.additional_comments}</Typography>
                                    </Box>:
                                <></>
                                }
                            </Box>

                        </>  
                    ))}
                </Box>
                 
            </Box>:
            <>
            </>
          }
          
          {Array.isArray(data.after_payment) && data.after_payment.findIndex(item=>item.remaining_days==0)>=0?
          <Typography sx={{mb:2,mt:2,color:"#ffce00",fontSize:"18px",fontWeight:600,minWidth:"150px"}}>
            <WarnIcon sx={{mb:-0.5,mt:0}}></WarnIcon> This new plan, when activated will be a downgrade from your current privileges - are you sure, you want to continue?
          </Typography>:
          <></>}
          {/* International client info box */}
          {props.isInternational?
          <>
          <Box sx={{mt:2,display:'flex',justifyContent:"start"}}>
                <Box sx={{display:'flex',mb:1,pb:0,background:"#fff",borderRadius:"8px",pl:2,pr:2,mt:1,flexDirection:'column',width:"100%"}}>
                <Typography sx={{mb:1,mt:1,textAlign:'center',color:"black",fontSize:"18px",fontWeight:600}}>NOTE: Additional INR {props.amountDifference} (incl GST) needs to be paid, as NSE charges higher variable fees for international end users.</Typography>
             </Box>
             </Box>
          </>:
          <>
          </>
          }
          <br/>
          {data.applicable_coupons != undefined && data.applicable_coupons.length > 0?
              <Box sx={{mt:0,display:'flex',justifyContent:"center",flexDirection:'column'}}>
              
              <Typography sx={{mb:1,mt:1,fontSize:"18px",fontWeight:600,alignSelf:"center"}}>Check and Apply Coupon Codes available for you: </Typography>
              {data.applicable_coupons.map(code => 
                 <>
                 <Button variant="contained" onClick={()=>applyRemoveCoupon(code)} sx={{ml:2,mb:1,width:"50%",marginTop:"6px",height:32, bgcolor:"#ffffff",color:"black",alignSelf:"center"}}>
                  {code}
                </Button>
                </>
              )}
              {/* <Button variant="contained" onClick={()=>applyRemoveCoupon(code)} sx={{ml:2,mb:1,width:"50%",marginTop:"6px",height:32, bgcolor:"#ffffff",color:"black",alignSelf:"center"}}>
                  {data.applicable_coupon}
              </Button> */}
                 
            </Box>
            :<></>
          }
           <Box sx={{mt:3,ml:1,display:'flex',justifyContent:'center',flexDirection:'column'}}>
              <Box sx={{mt:0,display:'flex',justifyContent:"center",flexDirection:'row'}}>
              {!codeApplied?
                <TextField
                  // autoFocus
                  // required
                  variant="outlined"
                  size="small"
                  value={code}
                  sx={{mt:0,maxWidth:300}}
                  onChange={(event) => handleCodeChange(event)}
                  inputProps={{ maxLength: 200 }}
                  id="code"
                  label="Coupon Code"
                  error={isCouponError}
                
                  
                /> :
                <>
                <CheckCircleOutlineIcon sx={{mt:1,mr:1,color:"#40b66e"}}></CheckCircleOutlineIcon>
                {/* <Box sx={{display:'flex',flexDirection:'column'}}> */}
                  <Typography  sx={{mb:1,color:"#fff",mt:1.2,fontWeight:600,minWidth:"140px"}}>Coupon applied: {couponCode}</Typography>
                  {/* <Typography  sx={{mb:1,color:"#fff",mt:0,fontWeight:600,minWidth:"140px"}}>{couponDesc}</Typography> */}
                {/* </Box> */}
                </>
                }
              
              {!codeApplied?
              <Button variant="contained" disabled={code==undefined || code=="" || code.trim().length<4} onClick={()=>applyRemoveCoupon(code)} sx={{ml:2,marginTop:"4px",height:32, bgcolor:"#ffffff",color:"black"}}>
                  Apply
                </Button>:
              <Button variant="contained" onClick={()=>applyRemoveCoupon(undefined)} sx={{ml:2,marginTop:"4px", height:32, bgcolor:"#ffffff",color:"black"}}>
                  Remove
              </Button>
              }
                 
            </Box>
          
            {isCouponError?
              <Typography sx={{ml:0,mt:1,display:"flex",justifyContent:"center",color:"#ec7171",fontSize:"16px"}}>{"Oops! The provided Coupon Code: '"+code+"' is not applicable here."}</Typography>
              :
              <>
              {/* Congratulations Message Card */}
              {couponDesc && couponDesc !== "" && (
                <Box sx={{
                  mt: 2,
                  mx: 'auto',
                  width: '95%',
                  maxWidth: 600,
                  background: 'linear-gradient(135deg, rgba(64, 182, 110, 0.15), rgba(142, 249, 126, 0.15))',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '10px',
                  border: '1px solid rgba(142, 249, 126, 0.4)',
                  boxShadow: '0 4px 16px rgba(142, 249, 126, 0.2)',
                  p: 2,
                  display: 'flex',
                  alignItems: diwaliOfferApplied ? 'flex-start' : 'center',
                  gap: 1.5
                }}>
                  <CheckCircleOutlineIcon sx={{ 
                    fontSize: '28px', 
                    color: '#8ef97e',
                    flexShrink: 0,
                    mt: diwaliOfferApplied ? 0.2 : 0
                  }} />
                  <Typography sx={{
                    color: '#8ef97e',
                    fontWeight: 600,
                    fontSize: '16px',
                    lineHeight: 1.5,
                    whiteSpace: 'pre-line'
                  }}>
                    {couponDesc}
                  </Typography>
                </Box>
              )}
              {diwaliOfferApplied && couponDesc && couponDesc !== "" && (
                <Box sx={{
                  mt: 1.5,
                  mx: 'auto',
                  width: '95%',
                  maxWidth: 600,
                  background: 'linear-gradient(135deg, rgba(255, 206, 0, 0.16), rgba(255, 152, 0, 0.12))',
                  borderRadius: '10px',
                  border: '1px solid rgba(255, 206, 0, 0.7)',
                  boxShadow: '0 4px 16px rgba(255, 206, 0, 0.18)',
                  p: 2
                }}>
                  <Typography sx={{
                    color: '#ffce00',
                    fontWeight: 700,
                    fontSize: '15px',
                    lineHeight: 1.5
                  }}>
                    {DIWALI_BOGO_NOTE}
                  </Typography>
                </Box>
              )}

              {/* Offer Description Card */}
              {codeApplied && orderDetail && orderDetail.discount_description && orderDetail.discount_description != ""?
              <Box sx={{
                mt: 2,
                mx: 'auto',
                width: '95%',
                maxWidth: 600,
                background: 'linear-gradient(135deg, rgba(251, 225, 3, 0.15), rgba(255, 193, 7, 0.15))',
                backdropFilter: 'blur(10px)',
                borderRadius: '10px',
                border: '1px solid rgba(251, 225, 3, 0.4)',
                boxShadow: '0 4px 16px rgba(251, 225, 3, 0.2)',
                p: 2.5,
                position: 'relative',
                overflow: 'hidden'
              }}>
                {/* Decorative corner accent */}
                <Box sx={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  width: '60px',
                  height: '60px',
                  background: 'linear-gradient(135deg, rgba(251, 225, 3, 0.2), transparent)',
                  borderRadius: '0 10px 0 100%'
                }} />
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                  <Typography sx={{
                    color: '#FBE103',
                    fontWeight: 700,
                    fontSize: '14px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    flexShrink: 0,
                    mt: 0.5
                  }}>
                    🎉 Offer:
                  </Typography>
                  <Typography sx={{
                    color: '#FBE103',
                    fontWeight: 600,
                    fontSize: '15px',
                    lineHeight: 1.6,
                    flex: 1
                  }}>
                    {orderDetail.discount_description}
                  </Typography>
                </Box>
              </Box>
              :<></>}
              {codeApplied && couponDesc != "" && orderDetail && orderDetail != undefined && orderDetail.final_cost != undefined && !isDiwaliBogo(orderDetail.discount_code)?
              <Box sx={{
                mt: 3,
                mx: 'auto',
                width: '95%',
                maxWidth: 600,
                background: 'linear-gradient(135deg, rgba(23, 42, 69, 0.9), rgba(30, 58, 138, 0.9))',
                backdropFilter: 'blur(10px)',
                borderRadius: '12px',
                border: '1px solid rgba(58, 134, 255, 0.3)',
                boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)',
                p: 2.5
              }}>
                {/* Pricing Summary Header */}
                <Typography sx={{
                  textAlign: 'center',
                  fontSize: '16px',
                  fontWeight: 700,
                  color: '#fff',
                  mb: 2.5,
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px'
                }}>
                  Pricing Summary
                </Typography>

                {/* Main Pricing Row - Clean Grid Layout */}
                <Box sx={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: 1,
                  mb: orderDetail.plan_months > 0 ? 2 : 0
                }}>
                  {/* Original Cost */}
                  <Box sx={{ 
                    display: 'flex', 
                    flexDirection: 'column',
                    alignItems: 'center',
                    p: 1.5
                  }}>
                    <Typography sx={{ 
                      fontSize: '12px', 
                      color: '#ADB5BD', 
                      fontWeight: 500,
                      mb: 1,
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px'
                    }}>
                      Original Cost
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'top', gap: 0 }}>
                      <RupeeIcon sx={{ fontSize: '24px', color: '#ADB5BD' }} />
                      <Typography sx={{
                        fontSize: '26px',
                        fontWeight: 600,
                        mt: -0.8,
                        color: '#ADB5BD',
                        textDecoration: 'line-through'
                      }}>
                        {orderDetail.original_cost?.toLocaleString('en-IN')}
                      </Typography>
                    </Box>
                  </Box>
                  
                  {/* Final Discounted Cost */}
                  <Box sx={{ 
                    display: 'flex', 
                    flexDirection: 'column',
                    alignItems: 'center',
                    p: 1.5
                  }}>
                    <Typography sx={{ 
                      fontSize: '12px', 
                      color: '#8ef97e', 
                      fontWeight: 500,
                      mb: 1,
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px'
                    }}>
                      Final Discounted Cost
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'top', gap: 0 }}>
                      <RupeeIcon sx={{ fontSize: '24px', color: '#8ef97e' }} />
                      <Typography sx={{
                        fontSize: '26px',
                        fontWeight: 700,
                        mt: -0.8,
                        color: '#8ef97e'
                      }}>
                        {orderDetail.final_cost?.toLocaleString('en-IN')}
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* Per Month Pricing - Only if plan_months exists */}
                {orderDetail.plan_months > 0?
                <>
                  <Box sx={{
                    width: '100%',
                    height: '1px',
                    background: 'rgba(58, 134, 255, 0.2)',
                    my: 2
                  }} />
                  <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: 1
                  }}>
                    <Box sx={{ 
                      display: 'flex', 
                      flexDirection: 'column',
                      alignItems: 'center',
                      p: 1
                    }}>
                      <Typography sx={{ 
                        fontSize: '11px', 
                        color: '#ADB5BD', 
                        fontWeight: 500,
                        mb: 0.5,
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}>
                        Original (Per Month)
                      </Typography>
                      <Box sx={{ display: 'flex', alignItems: 'top', gap: 0 }}>
                        <RupeeIcon sx={{ fontSize: '18px', color: '#ADB5BD' }} />
                        <Typography sx={{
                          fontSize: '18px',
                          fontWeight: 500,
                          color: '#ADB5BD',
                          mt: -0.5,
                          textDecoration: 'line-through'
                        }}>
                          {parseInt((orderDetail.original_cost / orderDetail.plan_months).toFixed(0)).toLocaleString('en-IN')}
                        </Typography>
                      </Box>
                    </Box>
                    
                    <Box sx={{ 
                      display: 'flex', 
                      flexDirection: 'column',
                      alignItems: 'center',
                      p: 1
                    }}>
                      <Typography sx={{ 
                        fontSize: '11px', 
                        color: '#8ef97e', 
                        fontWeight: 500,
                        mb: 0.5,
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}>
                        Discounted (Per Month)
                      </Typography>
                      <Box sx={{ display: 'flex', alignItems: 'top', gap: 0 }}>
                        <RupeeIcon sx={{ fontSize: '18px', color: '#8ef97e' }} />
                        <Typography sx={{
                          fontSize: '18px',
                          fontWeight: 700,
                          mt: -0.5,
                          color: '#8ef97e'
                        }}>
                          {parseFloat((orderDetail.final_cost / orderDetail.plan_months).toFixed(1)).toLocaleString('en-IN')}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </>
                :<></>}
              </Box>
              :<></>
              }
              </>
            }
            </Box>

            {data.final_cost != undefined && data.final_cost !== null ? <>
            <Box sx={{ mt: 2, mr: 2, display: 'flex', justifyContent: 'right' }}>
                <Typography sx={{ color: '#fbfcfc', fontSize: '14px', fontWeight: 600 }}>
                  Base Cost of Plan: &nbsp;<RupeeIcon sx={{ color: '#fbfcfc', fontSize: '15px', mb:-0.4 }} />{formatINR(data.original_cost)}
                </Typography>
            </Box>
            <Box sx={{ mt: 0, display: 'flex', justifyContent: 'center' }}>
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                background: 'linear-gradient(135deg, rgba(16,185,129,0.2), rgba(5,150,105,0.2))',
                border: '1px solid rgba(16,185,129,0.45)',
                borderRadius: '10px',
                px: 2,
                py: 1.4
              }}>
                <Typography sx={{ color: '#A7F3D0', fontSize: '16px', fontWeight: 700 }}>
                  Final Amount (after applicable discounts and offers)
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <RupeeIcon sx={{ color: '#6EE7B7', fontSize: '22px' }} />
                  <Typography sx={{ color: '#6EE7B7', fontSize: '22px', fontWeight: 700 }}>
                    {formatINR(data.final_cost)}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </> : null}

          {isRazorpayAllowed ? (
              <Box sx={{ mt: 3, mx: 'auto', width: '95%', maxWidth: 600 }}>
                <FormControl>
                  <FormLabel sx={{ fontWeight: 600, mb: 1 }}>
                    Select Payment Method
                  </FormLabel>

                  <RadioGroup
                    row
                    value={paymentMethod}
                    onChange={handlePaymentMethodChange}
                  >
                    <FormControlLabel
                      value={PAYMENT_METHOD_CCAVENUE}
                      control={<Radio />}
                      label="CC Avenue"
                    />
                    <FormControlLabel
                      value={PAYMENT_METHOD_RAZORPAY}
                      control={<Radio />}
                      label="Razorpay"
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
          ): (<></>)}
            <Box sx={{mt:3,display:'flex',justifyContent:"end"}}>
                <Button variant="contained" onClick={()=>cancel()} sx={{mr:2}}>
                Cancel
                </Button>
                <Button variant="contained" onClick={()=>proceed(couponCode)} sx={{mr:2,bgcolor:"#ffffff",color:"black"}}>
                Continue
                </Button>
              </Box>
         </Box>
         </Box>
      </Modal>

  );
}
